import { supabase } from "@/integrations/supabase/client";
import { isHeadFromReview, readDeliveryChain, resolveOwnWriteBack } from "@/write-back/deliveryChain";
import { useQuery } from "@tanstack/react-query";

export const useClassificationResultWriteBack = (
  inboundClassificationResultId: string | null | undefined,
  encounterId: string,
) =>
  useQuery({
    queryKey: ["write-back-result", encounterId, inboundClassificationResultId],
    enabled: !!inboundClassificationResultId,
    queryFn: async () => {
      // Every row, not maybeSingle, which turns a retry's second row into a PGRST116 and errors the column out.
      const { data, error } = await supabase
        .from("outbound_result_write_backs")
        .select("*")
        .eq("encounter_id", encounterId);
      if (error) throw error;

      const delivery = readDeliveryChain(data ?? []);

      return {
        // A coder's send carries the latest result's id too; only its review id says the codes were not this result's.
        ...resolveOwnWriteBack(
          delivery,
          (row) =>
            row.inbound_classification_result_id === inboundClassificationResultId && row.human_review_id === null,
        ),
        isCurrentWriteBackFromReview: isHeadFromReview(delivery),
      };
    },
  });
